export default __webpack_public_path__ + "static/media/home.84f87c20.svg";